define('vspot-angular/services/activity-tags-service',[], function () {
    'use strict';

    return ['resources.ActivityTags', function (ActivityTags) {
        var checkAlternateSpellings = function(tag) {
            if( !global_helper.blank(tag.alternate_spellings) ) {
                // We want to make sure they alternate spelling isn't just the upper or lower case
                // version of the tag name, since all the comparisons are done in lower case.
                var alts = tag.alternate_spellings.split(',');
                var fixedAlts = [];
                for(var a=0, aLen=alts.length; a<aLen; a++) {
                    if( alts[a].trim().toLowerCase() !== tag.name.trim().toLowerCase() ) {
                        // It's safe to keep
                        fixedAlts.push( alts[a].trim() );
                    }
                }

                if( alts.length !== fixedAlts.length ) {
                    // We changed something
                    tag.alternate_spellings = fixedAlts.join(',');
                }
            }
        };

        return {
            /*
             * Get a list of all the activity themes tags.
             *
             * @returns  Resource object. See /resources.js documentation for details
             *            Expected return data: {
             *                      loading: boolean, // Is the object actively getting data
             *                      status: boolean, // true if it worked, false on error
             *                      data: array_of_tags
             *                  }
             */
            query: function() {
                return ActivityTags.query();
            },
            get: function(id) {
                return ActivityTags.get({id: id});
            },
            save: function(postData) {
                // Make sure we have the minimum set of icon classes
                if( global_helper.blank(postData.icon_class) ) {
                    postData.icon_class = 'glyphicon glyphicon-tags';
                }
                checkAlternateSpellings(postData);
                return ActivityTags.save(postData);
            },
            update: function(postData) {
                // Make sure we have the minimum set of icon classes
                if( global_helper.blank(postData.icon_class) ) {
                    postData.icon_class = 'glyphicon glyphicon-tags';
                }
                checkAlternateSpellings(postData);
                return ActivityTags.update(postData);
            },
            delete: function(id) {
                return ActivityTags.delete({
                    id: id
                });
            }
        };
    }];
});

